export var NegativeMetric;
(function (NegativeMetric) {
    NegativeMetric["BounceRate"] = "bounceRate";
    NegativeMetric["ExitRate"] = "exitRate";
    NegativeMetric["ClickRepetition"] = "clickRepetition";
    NegativeMetric["Hesitation"] = "hesitation";
    NegativeMetric["HoverTime"] = "hoverTime";
    NegativeMetric["LoadingTime"] = "loadingTime";
    NegativeMetric["TimeBeforeFirstClick"] = "timeBeforeFirstClick";
    NegativeMetric["TimeBeforeFirstTap"] = "timeBeforeFirstTap";
})(NegativeMetric || (NegativeMetric = {}));
export var MetricWeb;
(function (MetricWeb) {
    MetricWeb["ConversionCount"] = "conversionCount";
    MetricWeb["ConversionRate"] = "conversionRate";
    MetricWeb["CartAverage"] = "cartAverage";
    MetricWeb["CartMedian"] = "cartMedian";
    MetricWeb["DragRateWeb"] = "dragRateWeb";
    MetricWeb["DragFlickRateWeb"] = "dragFlickRateWeb";
    MetricWeb["FlickRateWeb"] = "flickRateWeb";
    MetricWeb["Revenue"] = "revenue";
    MetricWeb["SessionTimeAverage"] = "sessionTimeAverage";
    MetricWeb["Views"] = "views";
    MetricWeb["VisitRate"] = "visitRate";
    MetricWeb["Visits"] = "visits";
    MetricWeb["ViewsVisits"] = "viewsVisits";
    MetricWeb["ElapsedTime"] = "elapsedTime";
    MetricWeb["ExitRate"] = "exitRate";
    MetricWeb["ScrollRate"] = "scrollRate";
    MetricWeb["BounceRate"] = "bounceRate";
    MetricWeb["ActivityRate"] = "activityRate";
    MetricWeb["LoadingTime"] = "loadingTime";
    MetricWeb["AverageRevenueAfterClick"] = "averageRevenueAfterClick";
    MetricWeb["ConversionAfterClick"] = "conversionAfterClick";
    MetricWeb["ConversionAfterHover"] = "conversionAfterHover";
    MetricWeb["TransactionAfterClick"] = "transactionAfterClick";
    MetricWeb["TransactionAfterHover"] = "transactionAfterHover";
    MetricWeb["ClickRate"] = "clickRate";
    MetricWeb["ClickRateSession"] = "clickRateSession";
    MetricWeb["TimeBeforeFirstClick"] = "timeBeforeFirstClick";
    MetricWeb["HoverRate"] = "hoverRate";
    MetricWeb["EngagementRate"] = "engagementRate";
    MetricWeb["EngagementRateLive"] = "engagementRateLive";
    MetricWeb["Hesitation"] = "hesitation";
    MetricWeb["HoverTime"] = "hoverTime";
    MetricWeb["ClickRepetition"] = "clickRepetition";
    MetricWeb["TotalClicks"] = "totalClicks";
    MetricWeb["TotalRevenueAfterClick"] = "totalRevenueAfterClick";
    MetricWeb["PageHeight"] = "pageHeight";
    MetricWeb["AverageConversionAfterClick"] = "avgConversionAfterClick";
    MetricWeb["AverageConversionAfterHover"] = "avgConversionAfterHover";
    MetricWeb["AverageTransactionAfterClick"] = "avgTransactionAfterClick";
    MetricWeb["AverageTransactionAfterHover"] = "avgTransactionAfterHover";
    MetricWeb["PageviewAverage"] = "pageviewAverage";
    MetricWeb["ExposureRate"] = "exposureRate";
    MetricWeb["ExposureTime"] = "exposureTime";
})(MetricWeb || (MetricWeb = {}));
export var MetricSDK;
(function (MetricSDK) {
    MetricSDK["AverageRevenueAfterTap"] = "revenuePerTap";
    MetricSDK["AverageConversionAfterTap"] = "avgConversionAfterTap";
    MetricSDK["AverageTransactionAfterTap"] = "avgTransactionAfterTap";
    MetricSDK["ConversionAfterTap"] = "conversionRatePerTap";
    MetricSDK["TransactionAfterTap"] = "conversionRatePerTap";
    MetricSDK["DragFlickRate"] = "dragFlickRate";
    MetricSDK["DragFlickRecurrence"] = "dragFlickRecurrence";
    MetricSDK["DragRate"] = "dragRate";
    MetricSDK["DragRecurrence"] = "dragRecurrence";
    MetricSDK["FlickRate"] = "flickRate";
    MetricSDK["FlickRecurrence"] = "flickRecurrence";
    MetricSDK["LandingRate"] = "landingRate";
    MetricSDK["SwipeRate"] = "dragFlickRate";
    MetricSDK["SwipeRecurrence"] = "dragFlickRecurrence";
    MetricSDK["TapCount"] = "tapCount";
    MetricSDK["TapRate"] = "tapRate";
    MetricSDK["TapRateSession"] = "tapRateSession";
    MetricSDK["TapRecurrence"] = "tapRecurrence";
    MetricSDK["TapDistribution"] = "tapDistribution";
    MetricSDK["TimeBeforeFirstTap"] = "timeBeforeFirstTap";
    MetricSDK["TotalRevenueAfterTap"] = "totalRevenueWithTap";
})(MetricSDK || (MetricSDK = {}));
export const Metric = Object.assign(Object.assign({}, MetricWeb), MetricSDK);
//# sourceMappingURL=metric.js.map